import React, { useEffect, useState } from 'react';

import styles from './MostRecent.module.css';

const transformDate = (date) => {
  return new Date(date).toLocaleString();
};

const MostRecent = props => {
  const [latestSticky, setLatestSticky] = useState(
    {
      date: new Date().toString(),
      image: "blank.jpeg",
      tags: ["loading..."]
    }
  );

  useEffect(() => {
    if (props.latestSticky) {
      // console.log('got something!');
      // console.log(props.latestSticky.date);
      setLatestSticky(prev => props.latestSticky);
    } else {
      // console.log('got nothing.');
    }
  }, [props.latestSticky]);

  return (
    <div className={styles.mostRecentContainer}>
      <h2>most recent:</h2>
      <div className={styles.stickyDiv}>
        <div className={styles.sticky}><img src={`https://no2.dev/stickynotes/api/uploads/stickies/${latestSticky.image}`} alt={`${latestSticky.tags[0]}-related drawing.`} /></div>
      </div>
      <div className={styles.labelDiv}>
        <div className={styles.label}>
          <p>{transformDate(latestSticky.date)}</p>
          <p>-</p>
          <p>{latestSticky.tags[0]}</p>
          </div>
      </div>
    </div>
  );
};

export default MostRecent;
